module.exports = __webpack_public_path__ + "static/media/success.be503d2d.svg";